import * as React from 'react';
import * as moment from 'moment';

import { IPackageListingState } from '../classes/package-listing';
import { connect } from 'react-redux';

import PackageListingContainerView from '../views/library/package-listing-container.view';
import { IPackageListingAppState } from '../redux-state/index';

interface IPackageListingContainerExternalProps {

}

interface StateToProps {
}

export type PackageListingContainerProps = IPackageListingContainerExternalProps & StateToProps;

export class PackageListingContainerBase extends React.Component<PackageListingContainerProps, any> {

    render() {
        return (
            <PackageListingContainerView {...this.props} />
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IPackageListingContainerExternalProps): StateToProps {
    return {
    }
}

export default connect<StateToProps>(mapStateToProps)(PackageListingContainerBase);